import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useLang } from "../../i18n/LangContext";
import { useSettings } from "../../context/SettingsContext";
import { formatPhone } from "../../lib/api";

export const Footer = () => {
  const { t } = useLang();
  const { settings } = useSettings();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[#2E2E3A] bg-[#0A0A0C] pb-28 md:pb-10 pt-14">
      <div className="container-x grid gap-10 md:grid-cols-3">
        <div className="space-y-4">
          <Logo />
          <p className="text-sm text-gray-400 max-w-xs">{t("footer.about")}</p>
        </div>
        <div className="space-y-2 text-sm">
          <h2 className="font-display text-lg font-bold uppercase text-white">{t("footer.contact")}</h2>
          {settings.phone ? (
            <a href={`tel:${settings.phone}`} className="block text-[#FACC15] font-semibold hover:underline" data-testid="footer-phone">{formatPhone(settings.phone)}</a>
          ) : (
            <p className="text-gray-400" data-testid="footer-phone-soon">{t("footer.phoneSoon")}</p>
          )}
          {settings.email && <a href={`mailto:${settings.email}`} className="block text-gray-300 hover:text-white" data-testid="footer-email">{settings.email}</a>}
          <p className="text-gray-400">{settings.service_area_text}</p>
        </div>
        <nav aria-label="Footer" className="flex flex-col gap-2 text-sm text-gray-300">
          <Link to="/request" className="hover:text-white">{t("nav.request")}</Link>
          <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">{t("nav.privacy")}</Link>
          <Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">{t("nav.terms")}</Link>
          <Link to="/admin/login" className="text-gray-500 hover:text-gray-300" data-testid="footer-admin-link">{t("nav.admin")}</Link>
        </nav>
      </div>
      <p className="container-x mt-10 text-xs text-gray-500">© {year} {settings.business_name}. {t("footer.rights")}</p>
    </footer>
  );
};
